import React, { useState, useEffect } from 'react';
import styles from './dwn-style.module.css';
import {useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';


const FitVerification = () => {
  

  const location = useLocation();
  const navigate = useNavigate();

  const [phoneNumber] = useState(location.state.preScreening.phoneNumber);
  const [preScreening] = useState(location.state.preScreening);
  const [pid] = useState(location?.state?.pid )

  const[access, setAccess] = useState(-1)


  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [youthWeightLBs , setYouthWeightLBs] = useState(0)
  const [caregiverWeightLBs , setCaregiverWeightLBs] = useState(0)
  const [youthFeet, setYouthFeet] = useState(0)
  const [youthInches, setYouthInches] = useState(0)
  const [caregiverFeet, setCaregiverFeet] = useState(0)
  const [caregiverInches, setCaregiverInches] = useState(0)
  const [youthAgeInMonths, setYouthAgeInMonths] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [dob, setDOB] = useState('');


  const handleDOBChange = (e) => {
    const dob = e.target.value;
    console.log(dob)
    const ageInMonths = calculateAgeInMonths(dob);
    setYouthAgeInMonths(ageInMonths); // Save the calculated age in months
    
    setDOB(dob)
    
  };

  const calculateAgeInMonths = (dob) => {
    const birthDate = new Date(dob);
    const currentDate = new Date();
  
    let yearsDifference = currentDate.getFullYear() - birthDate.getFullYear();
    let monthsDifference = currentDate.getMonth() - birthDate.getMonth();
    let daysDifference = currentDate.getDate() - birthDate.getDate();
  
    // Adjust months if the current day is before the birthday in the current month
    if (daysDifference < 0) {
      monthsDifference--;
    }
  
    // Adjust years if the current date is before the birthday in the current year
    if (monthsDifference < 0) {
      yearsDifference--;
      monthsDifference += 12;
    }
  
    const ageInMonths = yearsDifference * 12 + monthsDifference;
  
  
    return ageInMonths >= 0 ? ageInMonths : 0; // Ensure no negative age
  };



    // Authentication and access verification
    useEffect(() => {
      if (!pid) {
          navigate('/');
      } else {
          const body = { "username": pid, "scope": "participant" };
          let connectionString = "https://app.digitalwellnessnurse.com";
  
          fetch(`${connectionString}/api/portal/verify`, {
              method: 'POST',
              headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
              },
              credentials: "include",
              body: JSON.stringify(body),
          })
          .then((response) => {
              setAccess(response.status);
              return response.json();
          })
          .then((json) => {
              if (json.access !== 200) {
                  navigate('/');
              } 
          })
          .catch((error) => {
              console.error("Error verifying access:", error);
          });
      }
  }, [pid, navigate]);



  // Function to fetch eligibility data
  useEffect(() => {

    if (access !== 200 || !phoneNumber) return; // Ensure we fetch only when authenticated and phoneNumber is available


    const fetchEligibilityData = async () => {
      
      setLoading(true);
      setError('');
      try {
        const response = await fetch('https://app.digitalwellnessnurse.com/api/portal/fit/get-eligible', {  //https://app.digitalwellnessnurse.com  http://localhost:2001
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ phoneNumber }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.status}`);
        }

        const data = await response.json();
        console.log('Response Data:', data); // Debugging response data

        // Validate and set formData
        if (data && data.eligible) {
          setYouthWeightLBs(Math.round(convertToLBs(parseFloat(data.eligible.eligibilityResults.youthWeight))));
          setCaregiverWeightLBs(Math.round(convertToLBs(parseFloat(data.eligible.eligibilityResults.caregiverWeight))));
          setYouthFeet(convertToFeetAndInches(data.eligible.eligibilityResults.youthHeight).feet);
          setYouthInches(convertToFeetAndInches(data.eligible.eligibilityResults.youthHeight).inches);
          setCaregiverFeet(convertToFeetAndInches(data.eligible.eligibilityResults.caregiverHeight).feet);
          setCaregiverInches(convertToFeetAndInches(data.eligible.eligibilityResults.caregiverHeight).inches);
          setFormData(data.eligible); // Use the `eligible` field from the backend
        } else {
          throw new Error('Invalid response structure');
        }
      } catch (err) {
        console.error('Error:', err.message);
        setError('Failed to fetch eligibility data. Please check the phone number.');
      } finally {
        setLoading(false);
      }
    };

    fetchEligibilityData();
  }, [phoneNumber, access]); // Runs only when `phoneNumber` or `access` changes

  // Function to update formData fields dynamically
  const handleInputChange = (field, value) => {

    setFormData((prev) => ({
      ...prev,
      eligibilityResults: {
        ...prev?.eligibilityResults,
        [field]: value,
      },
    }));


  };


  const convertToFeetAndInches = (meters) => {
    const totalInches = meters * 39.37; // Convert meters to inches
    let feet = Math.floor(totalInches / 12); // Get whole feet
    let inches = Math.round(totalInches % 12); // Get remaining inches
  
    if (inches === 12) {
      feet += 1; // Increment feet if inches equal 12
      inches = 0; // Reset inches to 0
    }
  
    return { feet, inches };
  };

  const convertToMeters = (feet, inches) => {
    const totalInches = parseFloat(feet || 0) * 12 + parseFloat(inches || 0);
    return (totalInches / 39.37).toFixed(2); // Convert to meters
  };

 


  const convertToKgs = (lbs) => {
    return (parseFloat(lbs || 0) * 0.453592);
  };


  const convertToLBs = (kg) => (kg * 2.20462);




  const validateForm = (input) => {
    const missingFields = [];
  
    // Helper function to check null, empty string, or non-positive values
    const isInvalidValue = (value) => value === null || value === '' || value <= 0;
  
    // Validate youth-related fields
    if (isInvalidValue(input.youthHeight)) missingFields.push("Youth Height (must be a positive value)");
    if (isInvalidValue(input.youthWeight)) missingFields.push("Youth Weight (must be a positive value)");
    if (!input.youthGender) missingFields.push("Youth Gender");
    if (isInvalidValue(input.youthAgeInMonths)) missingFields.push("Youth DOB is invalid");
  
    // Validate caregiver-related fields
    if (isInvalidValue(input.caregiverHeight)) missingFields.push("Caregiver Height (must be a positive value)");
    if (isInvalidValue(input.caregiverWeight)) missingFields.push("Caregiver Weight (must be a positive value)");
  
    // Validate yes/no fields
    if (!input.hasSmartphones) missingFields.push("Smartphones Availability");
    if (!input.proficientInEnglish) missingFields.push("English Proficiency");
    if (!input.medicationsCausingWeightGain) missingFields.push("Medications Causing Weight Gain");
    if (!input.chronicCondition) missingFields.push("Chronic Condition");
    if (!input.plansOrCurrentlyPregnant) missingFields.push("Pregnancy Status");
    if (!input.mentalDisorderOrSuicidalThoughts) missingFields.push("Mental Disorder or Suicidal Thoughts");
    if (!input.cognitiveImpairments) missingFields.push("Cognitive Impairments");
    if (!input.unsafeToLoseWeight) missingFields.push("Safety to Lose Weight");
    if (!input.otherObesityTreatments) missingFields.push("Other Obesity Treatments");
    if (!input.isYouthAfricanAmerican) missingFields.push("Youth African American Status");
  
    if( Math.abs(input.ZIP).toString().length != 5) missingFields.push("ZIP (must be five digits)");

  
    // Handle missing fields
    if (missingFields.length > 0) {
      alert(`The following fields are missing or invalid:\n- ${missingFields.join("\n- ")}`);
      return false; // Form is not valid
    }
  
    return true; // Form is valid
  };



  const verifyEligibility = async () => {

    let input = {
      youthHeight: convertToMeters(youthFeet,youthInches),
      youthWeight:convertToKgs(youthWeightLBs),
      youthGender:formData.eligibilityResults.youthGender,
      youthAgeInMonths: youthAgeInMonths,
      caregiverHeight: convertToMeters(caregiverFeet,caregiverInches),
      caregiverWeight:convertToKgs(caregiverWeightLBs),
      hasSmartphones:formData.eligibilityResults.hasSmartphones,
      proficientInEnglish:formData.eligibilityResults.proficientInEnglish,
      medicationsCausingWeightGain:formData.eligibilityResults.medicationsCausingWeightGain,
      chronicCondition:formData.eligibilityResults.chronicCondition,
      plansOrCurrentlyPregnant:formData.eligibilityResults.plansOrCurrentlyPregnant,
      mentalDisorderOrSuicidalThoughts:formData.eligibilityResults.mentalDisorderOrSuicidalThoughts,
      cognitiveImpairments:formData.eligibilityResults.cognitiveImpairments,
      unsafeToLoseWeight:formData.eligibilityResults.unsafeToLoseWeight,
      otherObesityTreatments:formData.eligibilityResults.otherObesityTreatments,
      isYouthAfricanAmerican:formData.eligibilityResults.isYouthAfricanAmerican,
      ZIP:formData.eligibilityResults.ZIP,
      };

     if(validateForm(input))
     {
        const url = "https://app.digitalwellnessnurse.com/api/portal/fit/verify-eligibility";   //https://app.digitalwellnessnurse.com  http://localhost:2001
      
        try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(input),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        // If eligible, display a modal
        if (result.eligible) {
            var data = {eligible: {
                eligibilityResults:result
              }}

              setYouthWeightLBs(Math.round(convertToLBs(parseFloat(data.eligible.eligibilityResults.youthWeight))))
              setCaregiverWeightLBs(Math.round(convertToLBs(parseFloat(data.eligible.eligibilityResults.caregiverWeight))))
              setYouthFeet(convertToFeetAndInches(data.eligible.eligibilityResults.youthHeight).feet)
              setYouthInches(convertToFeetAndInches(data.eligible.eligibilityResults.youthHeight).inches)
              setCaregiverFeet(convertToFeetAndInches(data.eligible.eligibilityResults.caregiverHeight).feet)
              setCaregiverInches(convertToFeetAndInches(data.eligible.eligibilityResults.caregiverHeight).inches)
              setFormData(data.eligible); // Use the `eligible` field from the backend

              setShowModal(true);


           
          
        } else {
            alert("Unfortunately, you are not eligible for this study.");
        }
        } catch (error) {
        console.error("Error verifying eligibility:", error);
        alert("An error occurred while verifying eligibility. Please try again later.");
        }
     }



  }


  const handleProceed = () => {
    

    const updatedEligibilityResults = {
      ...formData?.eligibilityResults,
      dob: dob, // Explicitly pass dob
    };
    console.log("proceed dob")
    console.log(dob)
    setShowModal(false); // Close the modal
    console.log("Verification")
    console.log(updatedEligibilityResults)
    navigate('/FitOnboard', { state: { pid:pid, preScreening: preScreening , eligibilityResults: updatedEligibilityResults} });
  };

  const handleCancel = () => {
    setShowModal(false); // Close the modal without proceeding
  };




    

  return (



    <div className={styles.fitRecruitmentContainer}>


      {/* Render modal if showModal is true */}
      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h3>Proceed with Onboarding?</h3>
            <p>Do you want to onboard the eligible participant?</p>
            <div className={styles.modalActions}>
              <button onClick={handleProceed}>Proceed</button>
              <button onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Form Content */}
      {formData && (
        <>
        <section className={styles.bmiSection}>
        <h2 cclassName={styles.sectionTitle}>Body Mass Index (BMI)</h2>
        <div>
              <div className={styles.bmiEntry}>
                <h4 cclassName={styles.sectionTitle}>Youth Height</h4>
                <label className={styles.bmiLabel}>Feet (ft):</label>
                <input
                  type="numeric"
                  className="bmiInput"
                  value={youthFeet}
                  onChange={(e) =>
                    setYouthFeet(e.target.value)
                    
                  }
                />

                <label className={styles.bmiLabel}>Inches (in):</label>
                <input
                  type="numeric"
                  className="bmiInput"
                  value={youthInches}
                  onChange={(e) =>
                    setYouthInches(e.target.value)
                    
                  }
                />
              </div>

              <div className={styles.bmiEntry}>
                <label className={styles.bmiLabel}>Youth Weight (lbs):</label>
                <input
                  type="numeric"
                  className="bmiInput"
                  value={youthWeightLBs} // Display weight in lbs
                  onChange={(e) => setYouthWeightLBs(e.target.value)}
                />
              </div>


              <div className={styles.bmiEntry}>
                <label className={styles.bmiLabel}>Youth BMI Percentile (%): {formData.eligibilityResults.youthBMIResult.bmiPercentile}</label>
              </div>


              {/* Age Subsection */}
              <div cclassName={styles.bmiEntry}>
                <label cclassName={styles.bmiLabel}>Youth Date of Birth:</label>
                <input type="date" className="bmiInput" onChange={handleDOBChange} />
              </div>


              <div className={styles.bmiEntry}>
                <h4 cclassName={styles.sectionTitle}>Youth Gender</h4>
                <label className={styles.bmiLabel}>
                  <input
                    type="radio"
                    value="boy"
                    name="youthGender"
                    checked={formData.eligibilityResults.youthGender === 'boy'}
                    onChange={() => handleInputChange('youthGender', 'boy')}
                  />
                  Boy
                </label>
                <label className={styles.bmiLabel}>
                  <input
                    type="radio"
                    value="girl"
                    name="youthGender"
                    checked={formData.eligibilityResults.youthGender === 'girl'}
                    onChange={() => handleInputChange('youthGender', 'girl')}
                  />
                  Girl
                </label>
              </div>


              <div className={styles.bmiEntry}>
                <h4 cclassName={styles.sectionTitle}>Caregiver Height</h4>
                <label className={styles.bmiLabel}>Feet (ft):</label>
                <input
                  type="numeric"
                  className="bmiInput"
                  value={caregiverFeet}
                  onChange={(e) =>
                    setCaregiverFeet(e.target.value)
                    
                  }
                />

                <label className={styles.bmiLabel}>Inches (in):</label>
                <input
                  type="numeric"
                  className="bmiInput"
                  value={caregiverInches}
                  onChange={(e) =>
                    setCaregiverInches(e.target.value)
                  }
                />
              </div>

              <div className={styles.bmiEntry}>
                <label className={styles.bmiLabel}>Caregiver Weight (lbs):</label>
                <input
                  type="numeric"
                  className="bmiInput"
                  value={caregiverWeightLBs} // Display weight in lbs
                  onChange={(e) => setCaregiverWeightLBs(e.target.value)}
                />
              </div>


              <div className={styles.bmiEntry}>
                <label className={styles.bmiLabel}>Caregiver BMI: {Math.round(formData.eligibilityResults.caregiverBMI)}</label>
              </div>


              <h3 className={styles.sectionTitle}>Criteria</h3>




            <div className={styles.criteriaItem}>
              <label className={styles.criteriaQuestion}>
                ZIP Code
              </label>
              <input  type="numeric" className="bmiInput" value={Math.round(formData.eligibilityResults.ZIP)  || ''} onChange={(e) => handleInputChange('ZIP', e.target.value)} />
            </div>


            <div className={styles.criteriaItem}>
              <label className={styles.criteriaQuestion}>
                RUCA Code: {formData.eligibilityResults.RUCA}
              </label>
          </div>


          <div className={styles.criteriaItem}>
          <label className={styles.criteriaQuestion}>
            Does the youth identify as an African American?
          </label>
          <div>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                value="yes"
                checked={formData.eligibilityResults.isYouthAfricanAmerican === 'yes'}
                onChange={() => handleInputChange('isYouthAfricanAmerican', 'yes')}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                value="no"
                checked={formData.eligibilityResults.isYouthAfricanAmerican === 'no'}
                onChange={() => handleInputChange('isYouthAfricanAmerican', 'no')}
              />
              No
            </label>
          </div>
       </div>

          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Do you and the adolescent have separate Android or Apple smartphones with a mobile internet connection?
            </label>
            <div className={styles.criteriaOptions}>
              <label className={styles.criteriaOption}>
                <input
                  type="radio"
                  value="yes"
                  name="smartphones"
                  checked={formData.eligibilityResults.hasSmartphones === 'yes'}
                  onChange={() => handleInputChange('hasSmartphones', 'yes')}
                />
                Yes
              </label>
              <label className={styles.criteriaOption}>
                <input
                  type="radio"
                  value="no"
                  name="smartphones"
                  checked={formData.eligibilityResults.hasSmartphones === 'no'}
                  onChange={() => handleInputChange('hasSmartphones', 'no')}
                />
                No
              </label>
            </div>
          </div>


          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Are you and the adolescent proficient in English?
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="english"
                value="yes"
                checked={formData.eligibilityResults.proficientInEnglish === "yes"}
                onChange={() => handleInputChange("proficientInEnglish", "yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="english"
                value="no"
                checked={formData.eligibilityResults.proficientInEnglish === "no"}
                onChange={() => handleInputChange("proficientInEnglish", "no")}
              />
              No
            </label>
          </div>

          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Has the child been prescribed any medications, like steroids or antipsychotics, that might have caused weight gain?
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="medications"
                value="yes"
                checked={formData.eligibilityResults.medicationsCausingWeightGain === "yes"}
                onChange={() => handleInputChange("medicationsCausingWeightGain", "yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="medications"
                value="no"
                checked={formData.eligibilityResults.medicationsCausingWeightGain === "no"}
                onChange={() => handleInputChange("medicationsCausingWeightGain", "no")}
              />
              No
            </label>
          </div>

          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Does the child have a chronic condition, such as Down syndrome, Prader-Willi syndrome, or Cushing's syndrome, that could contribute to obesity?
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="chronicCondition"
                value="yes"
                checked={formData.eligibilityResults.chronicCondition === "yes"}
                onChange={() => handleInputChange("chronicCondition", "yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="chronicCondition"
                value="no"
                checked={formData.eligibilityResults.chronicCondition === "no"}
                onChange={() => handleInputChange("chronicCondition", "no")}
              />
              No
            </label>
          </div>

          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Are you or the youth currently pregnant or planning to become pregnant?
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="pregnancy"
                value="yes"
                checked={formData.eligibilityResults.plansOrCurrentlyPregnant === "yes"}
                onChange={() => handleInputChange("plansOrCurrentlyPregnant", "yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="pregnancy"
                value="no"
                checked={formData.eligibilityResults.plansOrCurrentlyPregnant === "no"}
                onChange={() => handleInputChange("plansOrCurrentlyPregnant", "no")}
              />
              No
            </label>
          </div>

          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Do you or the youth have a mental or emotional disorder, such as schizophrenia or another psychotic disorder, or have either of you experienced thoughts of suicide or harming others?
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="mentalDisorder"
                value="yes"
                checked={formData.eligibilityResults.mentalDisorderOrSuicidalThoughts === "yes"}
                onChange={() => handleInputChange("mentalDisorderOrSuicidalThoughts", "yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="mentalDisorder"
                value="no"
                checked={formData.eligibilityResults.mentalDisorderOrSuicidalThoughts === "no"}
                onChange={() => handleInputChange("mentalDisorderOrSuicidalThoughts", "no")}
              />
              No
            </label>
          </div>

          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Do you or the youth have serious cognitive impairments that make it difficult to complete questionnaires or follow instructions?
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="cognitiveImpairments"
                value="yes"
                checked={formData.eligibilityResults.cognitiveImpairments === "yes"}
                onChange={() => handleInputChange("cognitiveImpairments", "yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="cognitiveImpairments"
                value="no"
                checked={formData.eligibilityResults.cognitiveImpairments === "no"}
                onChange={() => handleInputChange("cognitiveImpairments", "no")}
              />
              No
            </label>
          </div>

          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Do you or the youth have a medical condition where losing weight would not be safe or recommended?
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="unsafeWeightLoss"
                value="yes"
                checked={formData.eligibilityResults.unsafeToLoseWeight === "yes"}
                onChange={() => handleInputChange("unsafeToLoseWeight", "yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="unsafeWeightLoss"
                value="no"
                checked={formData.eligibilityResults.unsafeToLoseWeight === "no"}
                onChange={() => handleInputChange("unsafeToLoseWeight", "no")}
              />
              No
            </label>
          </div>

          <div className={styles.criteriaItem}>
            <label className={styles.criteriaQuestion}>
              Do you or the youth plan to receive or are either of you currently receiving other obesity treatments, such as medication or bariatric surgery, within the next 6 months?
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="obesityTreatments"
                value="yes"
                checked={formData.eligibilityResults.otherObesityTreatments === "yes"}
                onChange={() => handleInputChange("otherObesityTreatments", "yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                name="obesityTreatments"
                value="no"
                checked={formData.eligibilityResults.otherObesityTreatments === "no"}
                onChange={() => handleInputChange("otherObesityTreatments", "no")}
              />
              No
            </label>
          </div>




        </div>
      </section>

           <button className={styles.submitBtn} type="button"  onClick={verifyEligibility} >Verify</button>
        </>
      )}
    </div>
  );
};

export default FitVerification;

